import React from 'react'
import 'typeface-roboto' // NOTE: material-uiデフォルトフォント設定
import { BrowserRouter } from 'react-router-dom'
import { I18nextProvider } from 'react-i18next'
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles'
import { CssBaseline } from '@mui/material'
import theme from 'ui/theme'
import Routes from 'app/routes'
import i18n from './i18n'

function App() {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <I18nextProvider i18n={i18n}>
          <BrowserRouter>
            <Routes />
          </BrowserRouter>
        </I18nextProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  )
}

export default App
